module.exports = __webpack_public_path__ + "img/share.1630993415105.png";